import axiosInstance from "../utils/axiosInstance";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const updateApplication = async (applicationId, formData) => {
  try {
    const response = await axiosInstance.put(`${API_BASE_URL}/spect/application/${applicationId}`, formData);
    return response.data;
  } catch (error) {
    console.error("API submission error:", error);
    throw error;
  }
};

export const fetchApplications = async (page, pageSize, sortBy, filter) => {
  try {
    const response = await axiosInstance.get("/spect/application", {
      params: { page, pageSize, sortBy, filter },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching applications:", error);
    throw error;
  }
};

export const fetchApplicationById = async (id, page, pageSize, sortBy, filter) => {
  try {
    const response = await axiosInstance.get(`/spect/application/getByCommunity/${id}`, {
      params: { page, pageSize, sortBy, filter },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching applications:", error);
    throw error;
  }
};

export const deleteApplication = async (id) => {
  try {
    const response = await axiosInstance.delete(`/spect/application/${id}`);
    console.log("Application deleted successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting Application:", error);
    throw error;
  }
};